import React, { useState } from 'react'
import { MpTypography } from '../shared'
import {
  Box,
  Button,
  Container,
  IconButton,
  InputAdornment,
} from '../shared/MaterialExports'
import TextField from '@mui/material/TextField'
import { forgotPassword } from '../../services/AuthenticationService'
import { useNavigate } from 'react-router-dom'
import AnalyticsManager from '../../services/AnalyticsManager'
import { AuthLoader } from '../gateways/AuthLoader'
import Loader from 'shared/components/atoms/Loader'

const PasswordReset = () => {
  const [email, setEmail] = useState<string>('')
  const [errorText, setErrorText] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  const onSubmit = async () => {
    setLoading(true)
    try {
      await forgotPassword(email)
      navigate('/changePassword', { state: { username: email } })
    } catch (error) {
      setLoading(false)
      if (error instanceof Error) {
        switch (error.name) {
          case 'InvalidUsername':
            setErrorText(
              'That is not a valid registered email. Please try again with a different address.',
            )
            break
          default:
            setErrorText(
              'There was an error processing your request. Please try again later.',
            )
            AnalyticsManager.error(`Unhandled Authorization error: `, error)
            break
        }
      } else {
        AnalyticsManager.error(`Unhandled Authorization error: `, error)
      }
    }
  }

  return (
    <AuthLoader>
      <Container fixed maxWidth={'sm'}>
        <Box
          mt="10px"
          display="flex"
          flexDirection="column"
          alignItems="left"
          justifyContent="left">
          <MpTypography variant={'subheader'} my={2}>
            Enter your email address to reset your password
          </MpTypography>
          <TextField
            helperText={'ex. john.smith@domain.com'}
            value={email}
            onChange={(event) => setEmail(event.target.value.replace(/\s/g, ''))}
            color={'primary'}
            variant={'outlined'}
            placeholder='Email'
            sx={{
              width:'100%',
              "& input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #1A1B20 inset !important",
                transition: "background-color 5000s ease-in-out 0s",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position={'end'} disablePointerEvents>
                  <IconButton aria-label="Enter your email" edge="end">
                   
                  </IconButton>
                </InputAdornment>
              ),
            }}
            autoComplete="email"
          />
          <Box sx={{ minHeight: 100 }}>
            <MpTypography color={'error'}>{errorText}</MpTypography>
          </Box>
          <Button
            variant={'contained'}
            sx={{ mt: 'auto', mb: 1,width:'100%' }}
            disabled={email == '' || loading}
            onClick={onSubmit}>
            <Box 
              sx={{
                display: 'flex',   
                alignItems: 'center',
                gap: 2,
                justifyContent: 'center',
                whiteSpace: 'nowrap',
                width: '20%',
                '& .MuiCircularProgress-root': {
                  color: '#5856d6 !important',
                  width: '20px !important',
                  height: '20px !important',
                },
                }}
              >
              <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
                Confirm Email
              </Box>
              <Loader loading={loading} />
            </Box>
          </Button>
        </Box>
      </Container>
    </AuthLoader>
  )
}

export default PasswordReset
